<div id="container" style="width: 100%; height: 100%">
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    [(update)]="updateFlag"
    style="width: 100%; height: 400px; display: block"
  >
  </highcharts-chart>
</div>
